import React from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import Helmet from "react-helmet"
import cookie from 'react-cookies'
import CookiesDialog from '../components/CookiesDialog';

import ScrollToTop from "react-scroll-up"


import "../css/main.scss"

export default class Template extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  constructor () {
    super()
    this.addAccept = this.addAccept.bind(this)
    this.state = {
      showCookieDialog: false
    }
  }

  handleScroll(e) {
    var scrollHeader = document.getElementById('header');
    if(scrollHeader) {
        if(scrollHeader.getBoundingClientRect().top !== 0) {
          scrollHeader.className='header scroll';
        } else {
          scrollHeader.className='header'
        }
    }
  }

  pageClick(e) {
    document.getElementsByTagName('body')[0].className=''
  }

  addAccept(e) {

    this.setState({ showCookieDialog: false });

    var myexpires = new Date();
    myexpires.setDate(new Date().getDate() + 10000);

    cookie.save('CookieDialog_agreed', new Date().getTime(), { path: '/', expires: myexpires });

  }

  componentDidMount() {

    this.handleScroll;
    window.addEventListener('click', this.pageClick, false);
    window.addEventListener('scroll', this.handleScroll);

    const CookieDialog_agreed = cookie.load('CookieDialog_agreed');

    if(!CookieDialog_agreed) {
      this.setState({ showCookieDialog: true });
    }
  }

  componentDidUpdate() {
    const CookieDialog_agreed = cookie.load('CookieDialog_agreed');
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { showCookieDialog } = this.state

    return (
      <div>

        {this.props.children()}

        <ScrollToTop showUnder={160}>
          <span className="totop"></span>
        </ScrollToTop>

        {showCookieDialog && <CookiesDialog controlFunc={this.addAccept} /> }

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js